import React from "react";

import "./main.css";
import "./media.css";

import { Switch, Route, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";

import OfficeRoutes from "./OfficeRoutes";
import RetailRoutes from "./RetailRoutes";
import WarehouseRoutes from "./WarehouseRoutes";
import { Page404 } from "../widgets/Page404";

class Routes extends React.Component {
  render() {
    return (
      <Router basename={'/edge'}>
        <Switch>
          <Route exact path="/">
            <Page404 />
            {/* <Redirect to='/office/dashboard' /> */}
          </Route>
          <Route exact path="/edge">
            <Page404 />
          </Route>
          <Route path="/office">
            <OfficeRoutes />
          </Route>

          <Route path="/retail">
            <RetailRoutes />
          </Route>

          <Route path="/warehouse">
            <WarehouseRoutes />
          </Route>
          <Route path="*" exact={true}>
            <Page404 />
          </Route>
          {/* <Route exact path="/noauth">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-1 pe-0 sideNavContainer">
                        <LeftNavbar activeKey="noauth" />
                      </div>
                      <div className="col-lg-11">
                        <Noauth />
                      </div>
                    </div>
                  </div>
                </Route> */}
        </Switch>
      </Router>
    );
  }
}
export default Routes;
